module.exports = __webpack_public_path__ + "img/des-5.a5f9b04a.jpg";